export const CUSTOMER = 'customer'
export const CANCELLATION = 'cancellation'
export const CONTACT = 'contact'
export const CONTRACT = 'contract'
export const SERVICE_NUMBER = 'service_number'
export const SERVICE_INVOICE = 'service_invoice'
export const TRAFFIC_INVOICE = 'traffic_invoice'
export const STAFF_MEMBER = 'staff_member'
export const PRODUCT_INVENTORY = 'product_inventory'
